import React from "react";
import PropTypes from "prop-types";
//Material imports
import Grid from "@mui/material/Grid";
import makeStyles from "@mui/styles/makeStyles";
//Limitless imports
import LandingTooltip from "../landing-tooltip/LandingTooltip";
import TextField from "@limitless/modern/inputs/text-field/TextField";
const useStyles = makeStyles(theme => ({
  basicInput: {
    marginTop: 16,
    marginBottom: 8
  },
  addIcon: {
    color: "rgba(0, 0, 0, 0.54)"
  },
  input: {
    "& input[type=number]": {
      "-moz-appearance": "textfield"
    },
    "& input[type=number]::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0
    }
  },
  [theme.breakpoints.up("sm")]: {
    basicInput: {
      marginRight: ({
        breakLine
      }) => breakLine ? 40 : 0,
      paddingRight: ({
        breakLine
      }) => !breakLine ? 24 : 0
    }
  }
}));
const BasicTextInput = ({
  content,
  onValueChange,
  values
}) => {
  const {
    stateCaptureKey,
    label,
    placeholder,
    tooltip,
    optional,
    breakLine,
    fullWidth = false,
    gridColumn = 6,
    type = "text",
    characterLimit
  } = content;
  const classes = useStyles({
    breakLine
  });
  const {
    value = "",
    errorMessage = ""
  } = values ? values[stateCaptureKey] : {};
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.basicInput,
    mt: 2,
    item: true,
    md: fullWidth ? 12 : gridColumn
  }, /*#__PURE__*/React.createElement(TextField, {
    id: `${label.toLowerCase()}Input`,
    label: label,
    onChange: e => {
      if (characterLimit && e.target.value.length <= characterLimit || !characterLimit) {
        onValueChange(stateCaptureKey, e.target.value);
      }
    },
    value: value,
    required: optional ? false : true,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : label,
    endAdornment: tooltip && /*#__PURE__*/React.createElement(LandingTooltip, {
      tooltip: tooltip
    }),
    error: errorMessage ? true : false,
    errorText: errorMessage,
    type: type,
    className: classes.input
  }));
};
export default BasicTextInput;
BasicTextInput.propTypes = {
  content: PropTypes.object.isRequired,
  onValueChange: PropTypes.func.isRequired,
  values: PropTypes.object
};